jQuery(document).ready(function ($) {
    const loadingClass = 'loading';

    $( document.body ).on('wc_fragments_loaded', function(){
        setTimeout(function(){
            $('.remove_from_cart_button').off('click', removeFromCartAction );
            $('.remove_from_cart_button').on('click', removeFromCartAction ); //re-init after fragment update
        }, 1000);
     });

    function removeFromCartAction () {
        const minicartLink = $('.vet-mini-cart__link');

        minicartLink.addClass(loadingClass);

        $(this).parent().addClass('removing');
        $(this).parent().append("<div class='vet-spinner vet-spinner--medium loaded'></div>");
    }

    $('.remove_from_cart_button').on('click', removeFromCartAction ); //init here

    /**
     * Mini cart calculate overflow height.
     */
    $('a.vet-mini-cart__link').hover(function () {
        let miniCartUl = $('ul.woocommerce-mini-cart.cart_list');

        if ( miniCartUl.find('li').length > 1 ) {
            let maxHeight = miniCartUl.find('li').eq(1).outerHeight() + miniCartUl.find('li').eq(1).outerHeight() + 10;
            miniCartUl.css('max-height', maxHeight);
        } else {
            miniCartUl.css('max-height', 160);
        }
    });

});